// extracted by mini-css-extract-plugin
export var container = "cost-module--container--afa86";
export var cost = "cost-module--cost--13b8d";
export var form = "cost-module--form--18177";
export var info = "cost-module--info--ebee5";
export var priceNew = "cost-module--price-new--9e871";
export var priceOld = "cost-module--price-old--7fc73";
export var priceWrap = "cost-module--price-wrap--016df";
export var tax = "cost-module--tax--12d6b";